import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericService } from 'app/_services/generic.service';
import { CalamityStatusModel} from './models/calamity-status.model';
import { environment } from "environments/environment";

@Injectable({
    providedIn: 'root',
})

export class CalamityStatusService extends GenericService<CalamityStatusModel> {
  rootApiUrl: string = environment.Services.AlphaURLSlot2;
  
  constructor(private http: HttpClient) {
        super(http, '/CalamityStatus/')
    }

    private generateHeaders() {
        return {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          }),
        };
      }

    getCalamityStatusByCulture(culture) {
        return this._http.get(
          this.rootUrl+ "/CalamityStatus/getByCulture/" + culture,
          this.generateHeaders()
        );
    }
}